import styled from "styled-components";

export const Wrapper = styled.div`
  transition: width 0.1s ease, transform 0.1s ease;
  transform: translateX(0);
  font-family: 'Roboto', sans-serif !important;

  position: fixed;
  top: 61px;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  padding-top: 40px;
  margin-right: ${(props) => (props.noMargin ? 0 : 20)}px;

  .interior {
    width: 370px;
  }

  @media only screen and (min-width: 1700px) {
    left: calc(50% + 110mm + 2rem);
  }

  @keyframes slide-right {
    0% {
      opacity: 0;
      transform: translateX(20px);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  &.hide {
    @media only screen and (max-width: 1700px) {
      width: 0;
      transform: translateX(30px);
    }
  }

  .sidebar-header {
    display: none;
    font-size: 20px;
    padding: 28px;
    padding-left: 60px;
    border-bottom: 1px solid #c3c3c3;

    .close-button {
      position: absolute;
      top: 17px;
      right: 10px;

      i {
        margin: 0;
      }

      &:hover {
        background: rgba(20, 20, 20, 0.1);
      }

      background: transparent;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      transition: background 0.1s 0.1s;
      user-select: none;
      border: none;
      box-shadow: none;
      outline: none;
    }
  }

  @media only screen and (max-width: 1700px) {
    width: 410px;
    padding: 0 1rem 1rem 1rem;
    margin-right: 0px;
    position: fixed;
    right: 0;
    top: 61px;
    bottom: 0;
    background: #e6e6e6;
    overflow-y: scroll;
    border-right: 1px solid #c3c3c3;

    .sidebar-header {
      display: block;
    }

    .title {
      display: none;
    }
  }


  .tertiary {
    background-color: inherit;
    color: ${props => props.theme.primary};
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
  }
  .tertiary.link {
    margin: 0;
    padding: 0;
  }
  .tertiary:hover {
    color: ${props => props.theme.primaryLight};
    background-color: inherit;
  }


  .debrief-new {
    margin-top: 1rem;
    font-size: 16px;
    color: #9e9e9e;
  }

  .heading {
    margin-bottom: 2rem;

    // .title {
    //   background-image:url('/debriefer-logo.png');
    //   background-repeat:no-repeat;
    //   background-size:16px 16px;
    //   padding-left: 20px;
    //   font-size: 14px;
    //   color: #026d94;
    //   text-transform: uppercase;
    //   font-family:Roboto,sans !important;
    // }

    .subtitle {
      opacity: 0.75;
      font-family: Roboto, sans !important;
      font-size: 28px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.32;
      letter-spacing: normal;
      text-align: left;
      color: #28404a;
      margin-top: 0;
      font-family: Roboto, sans;
    }

    button {
      text-transform: uppercase;
      font-weight: normal;
      font-family: Roboto, sans !important;
      font-size: 13px;
      font-weight: 500;
      color: #ffffff;
      letter-spacing: 0.65px;
    }

    p {
      font-family: Roboto, sans !important;
      opacity: 0.5;
      font-size: 16px;
      line-height: 1.31;
      color: #28404a;
    }

  }

  @keyframes slide-down {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .content {

    .card {
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      animation: slide-down 400ms ease;
      width: 100%;

      &.submitting {
        .content {
          .description {
            .tertiary {
              display: none;
            }
          }
        }
      }

      .content {
        padding: 1.25rem;
      }

      .header {
        font-family: Roboto;
        font-size: 21px;
        font-weight: 500;
        color: ${props => props.theme.primary};
        margin: 1rem 0;
      }

      .description {
        font-family: Roboto, sans !important;
        font-size: 16px;
        font-weight: 400;
        color: #757575;
      }

      .understate {
        display: block;
        font-family: Roboto, sans !important;
        font-size: 12px;
        color: #AEAEAE;
        line-height: 1.58;
      }

      .input {
        margin: 1.25rem 0;
        width: 100%;
      }

      button {
        float: right;
        text-transform: uppercase;
        font-weight: normal;
        font-family: Roboto, sans !important;
        font-size: 13px;
        font-weight: 500;
        color: #ffffff;
        letter-spacing: 0.65px;

        &:hover {
          background-color: ${props => props.theme.primaryLight};
        }

        &.tertiary {
          color: #026d94;

          &:hover {
            color: ${props => props.theme.primaryLight};
            background-color: inherit;
          }
      
        }

      }

    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Debriefs/style.js